module.exports = __webpack_public_path__ + "img/quanxian.png";